import React from 'react';

import {
  OverflowSpan,
  TooltipText,
} from '@/shared/components/ui/overflow-text/overflow-text.styled';
import { TOverflowTextProps } from '@/shared/components/ui/overflow-text/overflow-text.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { useTextOverflow } from '@/shared/hooks/use-text-overflow/use-text-overflow';

export const OverflowText: React.FC<TOverflowTextProps> = ({
  text,
  children,
  tooltipPlacement = 'bottom-start',
}) => {
  const { ref, isOverflowing } = useTextOverflow<HTMLSpanElement>(text);

  return (
    <Tooltip
      title={isOverflowing ? <TooltipText>{text}</TooltipText> : ''}
      arrow
      noMaxWidth
      placement={tooltipPlacement}
    >
      <OverflowSpan ref={ref}>{children ?? text}</OverflowSpan>
    </Tooltip>
  );
};
